/**
 * Copy for promoting the Findigo browser extension when users apply externally.
 * Snabbansökan: in-app när det går – annars erbjuder vi hjälp via tillägget på ansökningssidan.
 */

/** Kort text till toasts när vi öppnar extern ansökningssida. */
export const EXTENSION_HELP_TOAST =
  "Findigo-tillägget på ansökningssidan kan fylla i formuläret åt dig på många jobbsajter.";

/** Text i Did-you-apply-dialogen. */
export const EXTENSION_HELP_DID_YOU_APPLY =
  "Findigo-tillägget hjälper dig att fylla i formuläret och logga ansökan på många jobbsajter.";

/** Tooltip för knapp typ "Ansök via extern webplats". */
export const EXTENSION_HELP_BUTTON_TOOLTIP =
  "Öppnar ansökningssidan. Findigo-tillägget kan fylla i formuläret åt dig på många sajter.";

/** Kort tillägg till meningsavslut, t.ex. i ManualFallback eller AutoApplyPreview. */
export const EXTENSION_HELP_ALSO =
  "Findigo-tillägget på sidan kan också fylla i åt dig på många sajter.";

/** Chrome Web Store – Findigo - Jobbassistent */
export const EXTENSION_INSTALL_URL = "https://chromewebstore.google.com/detail/findigo-jobbassistent/ekjoomiocimepoddkpcakhlbandddaaf";

/** Extension ID (Chrome Web Store) – används för att detektera om tillägget är installerat. */
export const EXTENSION_ID = "ekjoomiocimepoddkpcakhlbandddaaf";

/** Knapptext / CTA för nedladdning. */
export const EXTENSION_DOWNLOAD_CTA = "Ladda ner Findigo-tillägget";
